<template>
  <div id="app">
    <router-view/>

    <PageFooter />
  </div>
</template>

<script>
import PageFooter from './components/PageFooter'

export default {
  components: {
    PageFooter
  }
}
</script>
